const ChatQueryKeys = {
  global: ["chats"] as const,

  /** List */
  list: () => [...ChatQueryKeys.global, "list"],

  /** Chat Details */
  /** @deprecated Internal: do not use */
  details: () => [...ChatQueryKeys.global, "details"] as const,
  /** Used to fetching a single Status */
  detail: (chatId?: string) => [...ChatQueryKeys.details(), chatId] as const,

  searchAccounts: (query?: string) =>
    [...ChatQueryKeys.global, "search", "accounts", query] as const,
  searchMessages: (query?: string) =>
    [...ChatQueryKeys.global, "search", "messages", query] as const,
  avatarPreviews: () =>
    [...ChatQueryKeys.global, "search", "previews"] as const,
};

export { ChatQueryKeys };
